import { Button, Card, Drawer, Tabs, Typography } from "antd";
import RecordDetails from "../recordDetails/recordDetails";
import React, { useEffect, useState } from "react";
import { AccessLevel, RowLevelAction } from "../../types/types";
import { GetRequest } from "../../utils/api";
import { useTranslation } from "react-i18next";

interface Section {
  blueprintEndpoint: string;
  urlParams: Map<string, string>;
  title: string;
}

interface Props {
  title: string;
  open: boolean;
  setOpen: (value: boolean) => void;
  isCreateFlow?: boolean;
  isRelatedInfo?: boolean;
  sections: Section[];
  platformAction: RowLevelAction;
  userAccessLevel: AccessLevel;
  customerNames?: any[];
  refreshTable: Function;
  allowEdits?: boolean;
  moduleCode: string;
}

const TabKeys = {
  DETAIL: "detail",
};

const { Text } = Typography;

const ViewMultipleRecord: React.FC<Props> = ({
  title,
  open,
  setOpen,
  isCreateFlow,
  isRelatedInfo,
  sections,
  platformAction,
  userAccessLevel,
  customerNames,
  refreshTable,
  allowEdits,
  // prefillColumns,
  moduleCode,
}) => {
  useEffect(() => {
    // This is where we basically collect the blueprint of all sections in ViewPage
    processSections();
  }, [open]);

  const [sectionBlueprintResponses, setSectionBlueprintResponses] = useState<
    any[]
  >([]);

  async function processSections() {
    try {
      const responses = await fetchAllViewBlueprint(sections);
      
      // Fetch JSON data from each response and update state
      const jsonDataArray = [];
      for (const response of responses) {
        const jsonData = await response.json();
        jsonDataArray.push(jsonData);
      }
      
      setSectionBlueprintResponses(jsonDataArray);
    } catch (error) {
      // Handle error if any REST calls fail
      console.error("Error while processing sections:", error);
    }
  }

  async function fetchAllViewBlueprint(sections: Section[]): Promise<any[]> {
    const promises: Promise<any>[] = sections.map((section) =>
      makeRestCall(section.blueprintEndpoint)
    );

    try {
      const responses = await Promise.all(promises);
      return responses;
    } catch (error) {
      // Handle Error
      console.error("Error while fetching responses:", error);
      throw error;
    }
  }

  async function makeRestCall(url: string): Promise<any> {
    return GetRequest(url);
  }

  const { t } = useTranslation();

  const items = [
    {
      label: t(`${title} Details`),
      key: TabKeys.DETAIL,
      children: (
        <>
          {sectionBlueprintResponses.length > 0 &&
            sections?.map((section, index) => (
              <Card className="m-3">
                <div>
                  <Text className="text-primary text-base font-medium">{section.title}</Text>
                </div>
                <div>
                  <div>
                    <RecordDetails
                      isCreateFlow={isCreateFlow}
                      isRelatedInfo={isRelatedInfo}
                      editForm={sectionBlueprintResponses[index].editForm}
                      viewPageBluPrint={section.blueprintEndpoint}
                      dataApi={sectionBlueprintResponses[index].dataApi}
                      dataApiMapper={
                        sectionBlueprintResponses[index].dataApiMapper
                      }
                      createApiMapper={
                        sectionBlueprintResponses[index].createApiMapper
                      }
                      viewApi={sectionBlueprintResponses[index].viewApi}
                      createApi={sectionBlueprintResponses[index].createApi}
                      recordId={section.urlParams.get("recordId") ?? ""}
                      urlparams={section.urlParams}
                      setOpen={setOpen}
                      userAccessLevel={userAccessLevel}
                      platformAction={platformAction}
                      parentEntity={
                        sectionBlueprintResponses[index].parentEntity
                      }
                      customerNames={customerNames}
                      refreshTable={refreshTable}
                      allowEdits={allowEdits ?? true}
                      moduleCode={moduleCode}
                      mulitiDependency={
                        sectionBlueprintResponses[index]?.mulitiDependency
                      }
                      title={title}
                      extraActionsOnRecord={
                        sectionBlueprintResponses[index]?.extraActionsOnRecord
                      }
                      platformActionLabels={
                        sectionBlueprintResponses[index]?.platformActionLabels
                      }
                    />
                  </div>
                </div>
              </Card>
            ))}
          {sections.length > 0 && (
            <div className="my-3">
              <Button color="primary" variant="solid">
                Reconcile
              </Button>
            </div>
          )}
        </>
      ),
    },
  ];

  return (
    <Drawer
      open={open}
      title={t(title)}
      destroyOnClose={true}
      onClose={() => {
        setOpen(false);
      }}
      maskClosable={false}
    >
      <Tabs items={items} />
    </Drawer>
  );
};

export default React.memo(ViewMultipleRecord);
